import React from 'react';
import styles from 'components/faceted-search/FacetBar.css';

const FacetBar = ({ children }) =>
  <div className={styles.container}>
    {children}
  </div>;

export default FacetBar;
